<script>
  export let row;
</script>

<div class="container">
  {#each Object.entries(row.permissions) as [permission, has_permission]}
    {#if has_permission}
      <div class="badge">
        {permission}
      </div>
    {/if}
  {/each}
</div>

<style>
  .container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }
  .badge {
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
    background: #f0f8ff;
    border-radius: 1px;
    margin-right: 10px;
    text-align: center;
    color: #43414b;
  }
  @media (max-width: 600px) {
    .container {
      flex-wrap: wrap;
    }
    .badge {
      margin-bottom: 0.5em;
    }
  }
</style>
